import {STATUSCHANGED} from "./actionTypes";

export const statusChange = (status)=>{
    return{
        type: STATUSCHANGED,
        payload: status,
    };
};